<val-fiche-generique #ficheGenerique
                     [titre]="ficheContenu.donnees?.titre ?? ''"
                     (fermerClick)="Fermer()">
  <div menu>
    <val-barre-menus [menuItems]="menuItems()"></val-barre-menus>
  </div>
  <div contenu class="val-facture-achat-fiche-contenu">
    <val-facture-achat-fiche-contenu #ficheContenu></val-facture-achat-fiche-contenu>
  </div>
</val-fiche-generique>
